function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Utillity manager for query string and url
 * @memberOf module:wdh-feature-b2b
 */
var UrlUtils = /*#__PURE__*/function () {
  function UrlUtils() {
    _classCallCheck(this, UrlUtils);
  }
  return _createClass(UrlUtils, null, [{
    key: "getParameterByName",
    value:
    /**
     * Get a query string parameter by name
     * @param {String} name    Name of the query string to get
     * @param {String} url     Url to get the value from
     * @returns {String}  Value found in the query string
     */
    function getParameterByName(name) {
      var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var newUrl = url;
      if (!newUrl) newUrl = window.location.href;
      var newName = name.replace(/[[\]]/g, '\\$&');
      var regex = new RegExp("[?&]".concat(newName, "(=([^&#]*)|&|#|$)"), 'i');
      var results = regex.exec(newUrl);
      if (!results) return null;
      if (Number.isNaN(results[2])) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    /**
     * Get a query string parameter by name and format it as number
     * @param {String} name    Name of the query string to get
     * @param {String} url     Url to get the value from
     * @returns {Number}  Number value found in the query string
     */
  }, {
    key: "getParameterNumberByName",
    value: function getParameterNumberByName(name, url) {
      var parameter = this.getParameterByName(name, url);
      return Number.parseInt(parameter, 10);
    }

    /**
     * Creates a link with querystrings
     * @param {String} prefix   Base url
     * @param {Object} args     key/value list of query strings to add to the url
     * @returns {String}        Created url
     */
  }, {
    key: "createLink",
    value: function createLink(prefix, args) {
      var keys = Object.keys(args);
      var queryString = '';
      for (var i = 0; i < keys.length; i += 1) {
        var currentKey = keys[i];
        if (i > 0) {
          queryString += '&';
        }
        queryString += "".concat(currentKey, "=").concat(args[currentKey]);
      }
      return encodeURI("".concat(prefix, "?").concat(queryString));
    }

    /**
     * Check if the current page is the entered page name
     * @param {String} pageName   Pagename to check against the current page name
     * @returns {Bool}            True if the current page is the entered page name, else false
     */
  }, {
    key: "isCurrentPage",
    value: function isCurrentPage(pageName) {
      var currentPageName = window.location.pathname;
      if (currentPageName.toLowerCase() === pageName.toLowerCase()) {
        return true;
      }
      return false;
    }
  }]);
}();
export default UrlUtils;